export const PAGINATION = {
  currentPage: 0,
  nextPage: 1,
  prevPage: 0,
  totalPages: 0,
  totalCount: 0,
};

export const STORE_PERSIST_BLACK_LIST = ['filter', 'franchise'];
